module.exports = __webpack_public_path__ + "static/media/cheese.b5bd6b8c.png";